import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';

const AskDialog = ({
  open,
  setOpen,
  okCallback,
  message,
}: {
  open: boolean;
  setOpen: (t: boolean) => void;
  okCallback: (param?: any) => void;
  message: string;
}) => {
  const handleClickOk = () => {
    okCallback();
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="lArea confirmLayer on">
        <div className="lBox">
          <Box className="lConArea on">
            <div className="lConMsg">{message}</div>
            <div className="lConBottom">
              <div className="lConBottomRight">
                <button
                  type="button"
                  className="bHeight03 bLineType03"
                  onClick={handleClose}
                >
                  <span>취소</span>
                </button>
                <button
                  type="button"
                  className="bHeight03"
                  onClick={handleClickOk}
                >
                  <span>확인</span>
                </button>
              </div>
            </div>
          </Box>
        </div>
      </div>
      {/* <DialogTitle id="alert-dialog-title">Use Google's location service?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Let Google help apps determine location. This means sending anonymous location data to Google, even when no
          apps are running.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Disagree</Button>
        <Button onClick={handleClickOk}>Agree</Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default AskDialog;
